import { Payout } from './payout';

export interface HayVnPayout extends Payout {
    wallet_account: string;
    deposit_trading_account: string;
    withdraw_reference: string;
    payout_method: string;
}
